<template>
  <span>
    <connected-user></connected-user>
    <channels></channels>
    <users></users>
  </span>
</template>

<script>
    import ConnectedUser from './ConnectedUser'
    import Channels from './Channels'
    import Users from './Users'
    export default {
      name: 'sidebar',
      components: { ConnectedUser, Channels, Users }
    }
</script>



// WEBPACK FOOTER //
// Sidebar.vue?faaa498c